import React from 'react';
import { Stack } from '@mui/material';
import { Help } from '@mui/icons-material';
import { Text } from '@innovyze/stylovyze';
import { InfoTooltip } from './InfoTooltip';

export const renderHeaderWithTooltip = (label: string, heading: string, content: string) => (
	<Stack direction="row" spacing={0.5} alignItems="center" sx={{ overflow: 'hidden', cursor: 'default' }}>
		<Text style={{ fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
			{label}
		</Text>
		<InfoTooltip heading={heading} content={content}>
			<Help sx={{ fontSize: 'small', color: '#9ca3af', flexShrink: 0, cursor: 'pointer' }} />
		</InfoTooltip>
	</Stack>
);
